import { createFileRoute, Outlet } from '@tanstack/react-router'
import { pageTitle } from '@/lib/page-title'

export const Route = createFileRoute('/(private)/exports')({
	head: ({ match }) => ({
		meta: [
			{
				title: pageTitle(
					match.context.appLanguage,
					'admin-exports:page_title'
				)
			}
		]
	}),
	staticData: {
		breadcrumb: 'admin-exports:page_title'
	},
	component: () => <Outlet />
})
